import React, { useEffect, useState, useRef } from "react";
import PublicCatalogLayout from "@/layouts/PublicCatalogLayout";
import { Button } from "@mui/material";
import EventsTable from "./EventsTable";
import EventModalRevised from "./EventModalRevised"
const EventsDashboardRevised = (props) => {
  const { archived, user, renter, shipping_addresses, renters} = props;
  const tableRef = useRef(null);
  const [updatedAt, setUpdatedAt] = useState(0);

  const renderLinks = () => {
    const linkClasses="text-[#3070E7] text-base font-normal"
    return (
      <div className={`pb-[20px] ${linkClasses}`}>
        <a href={`/events?archived=${archived ? "false" : "true"}`} > {archived ? "Active" : "Archived"} Events </a>
      </div>
    );
  }

  const reloadTable = () => {
    setUpdatedAt(updatedAt + 1);
  }

  const openEditModal = (id) => {
    setAddEventModalId(id);
    setAddEventModalOpen(true);
  }

  const [ eventModalOpen, setAddEventModalOpen ] = useState(false);
  const [ eventModalId, setAddEventModalId ] = useState(null);
  return (
    <PublicCatalogLayout
      {...props}
      groups={[]}
      currentPage="events"
      classNames={{body: 'white-background', container: 'full-width-container'}}
    >
      <EventModalRevised 
        open={eventModalOpen}
        id={eventModalId}
        onClose={() => {
          setAddEventModalOpen(false);
          reloadTable();
        }}
      />
      <div>
        <h1 class="catalog-h1">
          {archived ? "Archived " : ""}Events
          <div
            className="catalog-h1-float-right"
          >
            <Button variant="contained" color="green" onClick={()=>{
              setAddEventModalId(null);
              setAddEventModalOpen(true);
            }}>Add Event</Button>
          </div>
        </h1>
        {renderLinks()}
        <EventsTable
          openEditModal={openEditModal}
          ref={tableRef}
          archived={archived}
          shipping_addresses={shipping_addresses}
          renters={renters}
          user={user}
          renter={renter}
          key={`events-table-${updatedAt}`}
        />
      </div>

    </PublicCatalogLayout>
  );
}

export default EventsDashboardRevised